import type { FabricCanvasData } from '@canvas/shared-types';
import { withOffscreenCanvas } from '@/lib/offscreenCanvas';

/**
 * Render a stored page to a PNG data URL using an offscreen Fabric canvas.
 */
export async function renderPageToDataUrl(
  page: FabricCanvasData,
  multiplier = 1.5
): Promise<string> {
  try {
    return await withOffscreenCanvas(page, false, (canvas) =>
      canvas.toDataURL({
        format: 'png',
        multiplier,
        enableRetinaScaling: false,
      })
    );
  } catch (err) {
    throw err instanceof Error ? err : new Error('Failed to render page');
  }
}
